import React from "react";

export function EvidenceSearch({ ...rest }) {
  return <div {...rest}>EvidenceSearch</div>;
}
